import {
    Alert,
    AlertDescription,
    AlertIcon,
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Textarea,
    useToast,
    VStack
} from '@chakra-ui/react';
import { useState } from 'react';
import { createPSCLocation } from '../../api';

const CreatePSCLocationModal = ({ isOpen, onClose, setPSCLocations }) => {
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        hoursOfOperation: '',
    });
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [error, setError] = useState(null);
    const toast = useToast();



    const handleCreatePSCLocation = async () => {
        setError(null)
        if (!formData.name || !formData.address || !formData.hoursOfOperation) {
            setError("All fields are required")
            return;
        }

        setLoadingSubmit(true);

        try {
            const result = await createPSCLocation(formData);
            if (result.success) {
                setPSCLocations((prevLocations) => [result.data, ...prevLocations]);
                toast({
                    title: 'PSC Location Created Successfully',
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                });
                onClose()
            } else {
                setError(result.error)
            }
        } catch (error) {
            console.error('Error creating PSC location:', error);
        }
        setLoadingSubmit(false);

    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Create New PSC Location</ModalHeader>
                <ModalCloseButton />
                {error && <Alert status='error'><AlertIcon /><AlertDescription>{error}</AlertDescription></Alert>}

                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <FormControl isRequired>
                            <FormLabel>Location Name</FormLabel>
                            <Input
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter Location Name"
                            />
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel>Location Address</FormLabel>
                            <Input
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                placeholder="Enter Location Address"
                            />
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel>Hours of Operation</FormLabel>
                            <small>To add new line use  ,  Where you want to add new line</small>
                            <Textarea
                                name="hoursOfOperation"
                                value={formData.hoursOfOperation}
                                onChange={handleChange}
                                placeholder="Enter Hours of Operation (e.g. Monday - Friday, 8:30AM - 4:30PM)"
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme="blue" mr={3} isLoading={loadingSubmit} onClick={handleCreatePSCLocation}>
                        Create
                    </Button>
                    <Button variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default CreatePSCLocationModal;
